import React,{useState,useEffect,useRef} from "react";
import './ReleaseMusic.css'
import { Trans, useTranslation} from 'react-i18next'
import royaltyIcon from './../../../../images/rolaytyicon.png'
import axios from 'axios' 
import {useLocation,useNavigate} from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from "universal-cookie";

function RoyaltySplit({pagePath,setPagePath,files,setFiles,artistId,setArtistId,artistName}) {
    const ref = useRef(null)
    const {t, i18n } = useTranslation();
    // const [files,setFiles] = useState([])
    const [CollaboratorId,setCollaboratorId] = useState(0)
     //Royalty Split variables
     const [collaboratorArray,setcollaboratorArray] = useState([100,0])
     const [collaborator1Email,setcollaborator1Email] = useState("")
     const [collaborator1,setCollaborator1] = useState(false)
     const [collaborator2Email,setcollaborator2Email] = useState("")
     const [collaborator2,setCollaborator2] = useState(false)
     const [collaborator3Email,setcollaborator3Email] = useState("")
     const [collaborator3,setCollaborator3] = useState(false)
     const [collaboratorError,setCollaboratorError] = useState(false)
     const [collaboratorPercentError,setCollaboratorPercentError] = useState(false)
     const [checkCollaboratorArr,setCheckCollaboratorArr] = useState(0)
     const [royaltynextBtn,setRoyaltyNextBtn] = useState(false)
     const [assetId,setAssetId] = useState([])
     const navigate = useNavigate();
     const cookies = new Cookies(null ,{ path: '/' });
     const location = useLocation();

     {/*Enable next btn when all collaborators entered*/}

   
    useEffect(()=>{
        setRoyaltyNextBtn(true)
        files.map((file,index)=>{
         if(file.Collaborators.length===0){
                setRoyaltyNextBtn(false)
         }
        })
     },[checkCollaboratorArr])

     useEffect(()=>{

        if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
            setPagePath("/Dashboard/releasemusic/royaltysplit")
        }
      
        if(decodeToken(cookies.get('token')).info.role==="label"){
            setPagePath("/dashboard/label/releasemusic/royaltysplit")
        }

     },[])

     function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }

     const errorcheck = (id,index,CE,CPE) =>{
        if(!CE && !CPE && index!==null){
            handleCollaboratorInfoChange(id,index)
            // submitroyalty(id)
            setCollaboratorId(index)
        }
      }

       {/*get Artist Id*/} 
    const getArtistId = async (name) =>{
        return await axios.get("https://n3rve.fly.dev/artists?name=".concat(name))  
      }

      {/** Collaborator percent change*/}
      const handleCollaboratorInfoChange = (id,index) =>{
            console.log("###########")
            console.log(id)
            console.log(index)
            console.log(assetId[id])

            if(!collaborator1){
            if(files[id]!== undefined){
                files[id].Collaborators[0] = {name:artistId,percent:collaboratorArray[0]}
                files[id].Collaborators[1] = {name:9313303391,percent:collaboratorArray[1]}
                    console.log(files[CollaboratorId])
                    files[id].CollaboratorIds[0]=artistId
                    files[id].CollaboratorIds[1]=9313303391
                }
            }

            if(collaborator1){
            if(files[id]!== undefined){
                files[id].Collaborators[0] = {name:artistId,percent:collaboratorArray[0]}
                files[id].Collaborators[1]= {name:collaborator1Email,percent:collaboratorArray[1]}
                files[id].CollaboratorIds[0]=artistId
                getArtistId(collaborator1Email).then((res)=>{
                files[id].CollaboratorIds[1]= res.data.artist[0].id
                })
            }
            }


            if(files[index]!== undefined){
            if(files[index].Collaborators.length===0){
                setCollaborator1(false)
                setcollaborator1Email("")
                setcollaboratorArray([100,0])
            }
            if(files[index].Collaborators.length!==0){
                var arr1=0
                var arr2=0
                console.log("&&&&&&&&&&&&&&&&&&&&&&&&&")
                console.log(files[index].Collaborators)
                if(files[index].Collaborators[0]!==undefined){
                arr1=parseInt(files[index].Collaborators[0].percent)
                }

                if(files[index].Collaborators[1]!==undefined && files[index].Collaborators[1].name!==9313303391){
                    setCollaborator1(true)
                    setcollaborator1Email(files[index].Collaborators[1].name)
                    arr2=parseInt(files[index].Collaborators[1].percent)
                }

            

                setcollaboratorArray([arr1,arr2])
            }
            }
        }

        {/** Collaoboratoer Error check */} 
        const ChangeCollaborator = (v1,v2,id,index) =>{
            console.log(v1)
            console.log(v2)

            var sum

            if(v1===null && v2===null){
            sum = collaboratorArray[0] + collaboratorArray[1]
            }
        
            // var sum=collaboratorArray[0]
            if(v1!==null){
            sum =v1
            }
        
            var CE = false
            var CPE = false
            var CE1 = false

            if(collaborator1){
            if(collaborator1Email.length===0){
                CE1 = true
            }else{
                CE1 = false
            }
            }


            if(collaborator1){
            if(v2!==null)
            {
                sum=sum+v2
            }
            // sum=sum+collaboratorArray[1]
            }

        
            if(sum!==100){
            setCollaboratorPercentError(true)
            CPE = true
            }else{
            setCollaboratorPercentError(false)
            CPE = false
            }

            if(CE1){
            setCollaboratorError(true)
            CE=true
            }else{
            setCollaboratorError(false)
            CE=false
            }

            errorcheck(id,index,CE,CPE)

        }

    return (
            <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
            <div className="AddMusicHeader">{t('Royaltysharing')}</div>
        
            <div className="AddMusicDesc">
            <Trans i18nKey="Royaltysharingeasily" components={{1:<br/>}} >
                Royalty Sharing easily divide your track's earnings among collaborators<br/> such as producers and featured artists.
                        </Trans></div>

            <div style={{display:'flex',flexDirection:'row',width:'73.82%'}}>
                <div className="RoyaltyLeftContainer">
                    <div className="TracksTxt">{t('Tracks')}</div>
                    {
                    files.map((file,index)=>{
                    
                    return (
                        <div style={{width:'90%'}}>
                        {
                        CollaboratorId===index &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'100%',marginBottom:'1em',borderRadius:'8px',backgroundColor:'rgba(255,255,255,50%',cursor:'pointer',paddingTop:'0.5em',paddingBottom:'0.5em'}} onClick={()=>{ChangeCollaborator(null,null,CollaboratorId,index); setCheckCollaboratorArr(Math.random())}}> 
                        <div className="TrackNumber">
                            {index+1}.
                        </div>

                        <div className="TrackName">
                            {file.Tracktitle}
                        </div>
                                    
                        </div>
                        }

                        {
                        CollaboratorId!==index &&
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'100%',marginBottom:'1em',borderRadius:'8px',cursor:'pointer',paddingTop:'0.5em',paddingBottom:'0.5em'}} onClick={()=>{ChangeCollaborator(null,null,CollaboratorId,index); setCheckCollaboratorArr(Math.random())}}> 
                        <div className="TrackNumber">
                            {index+1}.
                        </div>

                        <div className="TrackName">
                            {file.Tracktitle}
                        </div>
                                    
                        </div>
                        }
                        </div>
                        
                    )
                    })
                }
                </div>

                {
                files[CollaboratorId].Collaborators.length===0 &&
                <div className="RoyaltyRightContainer">
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'95.46%',marginBottom:'1.156em'}}>
                    <div className="TracksTxt">
                    {t('Collaborators')}
                    </div>

                    <div className="TracksTxt">
                    {t('Royaltysplit')}
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'95.46%'}}>
                    <div className="CollaboratorTxt">
                    {artistName}&nbsp; (You)
                    </div>

                {
                    !collaborator1 &&
                    <input
                                value={collaboratorArray[0]}
                                onChange={e => {setcollaboratorArray([parseInt(e.target.value),0]);ChangeCollaborator(parseInt(e.target.value),0,CollaboratorId,null)}} 
                                className='RoyaltySplitBox'
                                type='number'
                                />
                }

                {
                    collaborator1 &&
                    <input
                                value={collaboratorArray[0]}
                                onChange={e => {setcollaboratorArray([parseInt(e.target.value),collaboratorArray[1]]);ChangeCollaborator(parseInt(e.target.value),collaboratorArray[1],CollaboratorId,null)}} 
                                className='RoyaltySplitBox'
                                type='number'
                                />
                } 

                    
                </div>

                {
                collaborator1 &&
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'95.46%'}}>
                <input
                            value={collaborator1Email}
                            onChange={e => {setcollaborator1Email(e.target.value);ChangeCollaborator(null,null,CollaboratorId,null)}} 
                            className='Collaboratorbox'
                            type='text'
                            placeholder="Enter Collaborator Name"
                />

                <img src={royaltyIcon} style={{width:'2.5em',height:'2.5em',marginTop:'0.5em',cursor:'pointer'}} onClick={()=>{setCollaborator1(false);ChangeCollaborator(collaboratorArray[0],0,CollaboratorId,null)}}/>

                
                <input
                value={collaboratorArray[1]}
                onChange={e => {setcollaboratorArray([collaboratorArray[0],parseInt(e.target.value)]);ChangeCollaborator(collaboratorArray[0],parseInt(e.target.value),CollaboratorId,null)}} 
                className='RoyaltySplitBox'
                type='number'  
                />
                

                
                </div>
                
                }



                {
                !collaborator1  &&
                <div className="AddCollabBtn" onClick={()=>{
                    if(!collaborator1){
                    setCollaborator1(true);
                    }
                
                    }}>
                    + &nbsp; {t('Addcollaborator')}
                </div>
                }
                            
            </div>
                }

            {
                files[CollaboratorId].Collaborators.length!==0 &&
                <div className="RoyaltyRightContainer">
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'95.46%',marginBottom:'1.156em'}}>
                    <div className="TracksTxt">
                    Collaborator
                    </div>

                    <div className="TracksTxt">
                    Royalty Split
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'95.46%'}}>
                    <div className="CollaboratorTxt">
                    {artistName}&nbsp; (You)
                    </div>

                {
                    !collaborator1 &&
                    <input
                                value={collaboratorArray[0]}
                                onChange={e => {setcollaboratorArray([parseInt(e.target.value),0]);ChangeCollaborator(parseInt(e.target.value),0,CollaboratorId,null)}} 
                                className='RoyaltySplitBox'
                                type='number'
                                
                                />
                }

                {
                    collaborator1 &&
                    <input
                                value={collaboratorArray[0]}
                                onChange={e => {setcollaboratorArray([parseInt(e.target.value),collaboratorArray[1]]);ChangeCollaborator(parseInt(e.target.value),collaboratorArray[1],CollaboratorId,null)}} 
                                className='RoyaltySplitBox'
                                type='number'
                                />
                } 

                    
                </div>

                {
                collaborator1 &&
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'95.46%'}}>
                <input
                            value={collaborator1Email}
                            onChange={e => {setcollaborator1Email(e.target.value);ChangeCollaborator(null,null,CollaboratorId,null)}} 
                            className='Collaboratorbox'
                            type='text'
                            placeholder="Enter Collaborator Name"
                />

                <img src={royaltyIcon} style={{width:'2.5em',height:'2.5em',marginTop:'0.5em',cursor:'pointer'}} onClick={()=>{setCollaborator1(false);ChangeCollaborator(collaboratorArray[0],0,CollaboratorId,null)}}/>

                <input
                value={collaboratorArray[1]}
                onChange={e => {setcollaboratorArray([collaboratorArray[0],parseInt(e.target.value)]);ChangeCollaborator(collaboratorArray[0],parseInt(e.target.value),CollaboratorId,null)}} 
                className='RoyaltySplitBox'
                type='number'
                
                />
                
                </div>
                
                }


                {
                !collaborator1  &&
                <div className="AddCollabBtn" onClick={()=>{
                    if(!collaborator1){
                    setCollaborator1(true);
                    }
                
                    }}>
                    + &nbsp; {t('Addcollaborator')}
                </div>
                } 
                            
            </div>
                }
                
            </div>

            {
                        collaboratorError && 
                        <div className='ErrorTxt' style={{marginTop:'1em'}}>Collaborator Name cannot be empty</div>
            }

            {
                        collaboratorPercentError && 
                        <div className='ErrorTxt' style={{marginTop:'1em'}}>Royalty Split must add up to 100</div>
            }
            
            <div className="RoyaltyPageDisclaimer">
            {t('Youcanmodifycollab')}
            </div>

            <div style={{display:'flex',flexDirection:'row',marginTop:'3.5em',paddingBottom:'4em'}}>
                <div className="BackBtn2" onClick={()=>{
                    {/**PENDING */}
                    // setPageNo(4);
                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/trackdetails");
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/trackdetails")
                      }
                   
                    topFunction()}}>
                {t('Back')}
                </div>

                {
                royaltynextBtn &&
                <div className="NextBtn2" onClick={()=>{
                     {/**PENDING */}
                    // setPageNo(6);
                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/releasedate")
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/releasedate")
                      }
                   
                    topFunction()}}>
                    {t('Next')}
                    <div className="PostLoginBtnOverlay"/>
                </div>
                }

                {
                !royaltynextBtn &&
                <div className="NextBtn2" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                {t('Next')}
                </div>
                }

                

            </div>
        </div>
        
    );
}

export default RoyaltySplit;